import React, { useEffect, useState } from 'react';
import {
  Avatar,
  Button,
  Checkbox,
  List,
  ListItem,
  ListItemSecondaryAction,
  ListItemText,
  Typography,
  InputBase
} from '@mui/material';
import { Delete as DeleteIcon } from '@mui/icons-material';
import { observer } from 'mobx-react-lite';

import agent from '../../lib/agent';
import useStores from '../../stores/useStores';

function AccountSettings({ account, onDelete }) {
  const { userStore } = useStores();

  const [settings, setSettings] = useState([
    {
      label: 'Prospecting',
      enabled: false,
      value: 'prospecting'
    },
    {
      label: 'Documents',
      enabled: false,
      value: 'documents'
    },
    {
      label: 'Team Manager',
      enabled: false,
      value: 'team_manager'
    },
    {
      label: 'Analytics',
      enabled: false,
      value: 'analytics'
    }
  ]);

  useEffect(() => {
    (async () => {
      const { data } = await agent.Group.getSettings(account.id);
      setSettings(data.data.menu_items);
    })();
  }, [account]);

  const handleDelete = async groupId => {
    if (!confirm(`Delete group ?`)) return;

    const currentGroupId = userStore.user.group.id;
    if (currentGroupId === groupId) {
      alert('Error: Switch active group first');
      return;
    }
    userStore.deleteGroup(groupId);
    if (onDelete) onDelete(groupId);
  };

  const handleToggle = value => () => {
    const newSettings = [...settings];
    const setting = newSettings.find(s => s.value === value);
    setting.enabled = !setting.enabled;
    setSettings(newSettings);

    const menuItems = settings.reduce((acc, val) => {
      if (val.enabled) {
        acc.push(val.value);
      }

      return acc;
    }, []);

    agent.Group.setSettings(account.id, {
      menu_items: menuItems
    });
  };

  const handleOnBlur = event => {
    const { value } = event.target;
    agent.Group.update(account.id, {
      description: value
    });
    const idx = userStore.user.groups.findIndex(
      group => group.id === account.id
    );

    userStore.user.groups[idx].description = value;
  };

  return (
    <>
      <div style={{ padding: 16, display: 'flex' }}>
        <Avatar style={{ marginRight: 16 }} />
        <div className="account-info-block-details">
          <Typography variant="h6">{account?.name}</Typography>
          <Typography variant="body2">
            <InputBase
              defaultValue={account?.description}
              onBlur={handleOnBlur}
              placeholder="Write decription here"
            />
          </Typography>
        </div>
      </div>

      <List dense>
        {settings.map(setting => {
          return (
            <ListItem key={setting.value} button>
              <ListItemText primary={setting.label} />
              <ListItemSecondaryAction>
                <Checkbox
                  edge="end"
                  checked={
                    settings.find(s => s.value === setting.value).enabled
                  }
                  onChange={handleToggle(setting.value)}
                />
              </ListItemSecondaryAction>
            </ListItem>
          );
        })}
      </List>

      <div style={{ padding: 16, paddingTop: 0 }}>
        <Button
          variant="contained"
          color="secondary"
          onClick={() => {
            handleDelete(account.id);
          }}
          startIcon={<DeleteIcon />}
        >
          Delete
        </Button>
      </div>
    </>
  );
}

export default observer(AccountSettings);
